module.exports = __webpack_public_path__ + "media/icons/not_verified-08dcfd39.png";